import { LAYER_ROLES } from '../layerTypes';
import { DEFAULT_BRAND_NAME_TEXT_TRANSFORM, DEFAULT_SLOGAN_TEXT_TRANSFORM } from './constants';

const ROLES_DEFAULT_TEXT_TRANSFORM_MAP = {
    [LAYER_ROLES.BRAND_NAME]: DEFAULT_BRAND_NAME_TEXT_TRANSFORM,
    [LAYER_ROLES.SLOGAN]: DEFAULT_SLOGAN_TEXT_TRANSFORM,
};

/**
 * Returns the default text transform of a given text layer role
 * @param {String} layerRole The layer role
 * @returns {String}
 */
const getDefaultTextTransformByRole = (layerRole) => {
    const roleTextTransform = ROLES_DEFAULT_TEXT_TRANSFORM_MAP[layerRole];

    if (!roleTextTransform) {
        throw new Error(`Cannot get default text transform for : ${layerRole}`);
    }

    return roleTextTransform;
};

export default getDefaultTextTransformByRole;
